import { useCallback } from "react";
import { generateCustomeId, hasEditedTrue } from "../utils/index1";

const useQaErrorTracking = ({ eobFormGetValues, eobFormSetValues,isQaScreen }) => {

//   // Early return if QA error already exists
//   if (eobFormGetValues('isQaError')) {
//     return;
//   }

  const toggleQaErrorTrue = useCallback(() => {
    eobFormSetValues('isQaError', true);
  }, [eobFormSetValues]);

  const addQaErrorIds = useCallback((field, ids) => {
    const currentSet = eobFormGetValues(field) || new Set();
    const newSet = new Set(currentSet);
    const idsArray = Array.isArray(ids) ? ids : [ids];
    
    idsArray.forEach(id => newSet.add(id));
    eobFormSetValues(field, newSet);
  }, [eobFormSetValues, eobFormGetValues]);

  const removeQaErrorIds = useCallback((field, ids) => {
    const currentSet = eobFormGetValues(field) || new Set();
    const newSet = new Set(currentSet);
    const idsArray = Array.isArray(ids) ? ids : [ids];
    
    idsArray.forEach(id => newSet.delete(id));
    eobFormSetValues(field, newSet);
  }, [eobFormSetValues, eobFormGetValues]);

const getGridEdited = useCallback(() => {
  const isQaError = eobFormGetValues('isQaError') ?? false;
  const errorClaimId = eobFormGetValues('errorClaimId') ?? new Set();
  const errorNewClaimId = eobFormGetValues('errorNewClaimId') ?? new Set();

  return Boolean(isQaError) || errorClaimId.size > 0 || errorNewClaimId.size > 0;
}, [eobFormGetValues]);


  const handleQaErrorCheck = useCallback((state) => {
    const claims = eobFormGetValues('claims')
    const currentClaim = claims?.[0]; // Added optional chaining
    if (!currentClaim || !isQaScreen) return;

    const claimId = currentClaim.claim_id;
    const customClaimId = currentClaim.edited_data?.custom_claim_id;
    const isEdited = hasEditedTrue(claims); // Wrap in array since hasEditedTrue expects array

    switch (state) {
      case 'save_or_next_or_copy':
        if (isEdited) {
          if (claimId) {
            addQaErrorIds('errorClaimId', claimId);
          } else if (customClaimId) {
            addQaErrorIds('errorNewClaimId', customClaimId);
          } else {
            const newCustomId = generateCustomeId();
            addQaErrorIds('errorNewClaimId', newCustomId);
            eobFormSetValues('claims.0.edited_data.custom_claim_id', newCustomId);
          }
        } else {
          // Remove from both sets to ensure clean state
          if (claimId) {
            removeQaErrorIds('errorClaimId', claimId);
          }
          if (customClaimId) {
            removeQaErrorIds('errorNewClaimId', customClaimId);
          }
        }
        break;

      case 'delete':
        if (!customClaimId) {
          toggleQaErrorTrue();
        }
        removeQaErrorIds('errorClaimId', claimId);
        removeQaErrorIds('errorNewClaimId', customClaimId);
        break;

    }
  }, [hasEditedTrue, addQaErrorIds, removeQaErrorIds, toggleQaErrorTrue, generateCustomeId, eobFormSetValues]);


  function hasQAErrorInHeader(formData) {
    if (!formData?.edited_data) return false;
    
    const editedData = formData.edited_data;
    
    for (const key in editedData) {
        if (editedData[key]?.error === true) {
            return true;
        }
    }
    
    return false;
}
  // Return the hook API
  return {
  
    handleQaErrorCheck,
    getGridEdited,
    hasQAErrorInHeader,
 
  };
};

export default useQaErrorTracking;